import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';

import { CAMPAIGN_TYPE } from '../constants';

const SelectCampaignType = ({ campaignType, onClick }) => {
  const buttonClassName = selected =>
    classnames('c-btn c-btn--white c-btn--active-branding u-1/1', {
      'is-active': selected,
    });

  return (
    <div>
      <h2 className="c-heading u-mb-">Select Campaign Type</h2>
      <div className="layout c-campaign-type">
        <div className="layout__item u-1/3">
          <button
            type="button"
            className={buttonClassName(campaignType === CAMPAIGN_TYPE.promotion)}
            onClick={onClick(CAMPAIGN_TYPE.promotion)}
          >
            Promotion
          </button>
        </div>
        <div className="layout__item u-1/3">
          <button
            type="button"
            className={buttonClassName(campaignType === CAMPAIGN_TYPE.update)}
            onClick={onClick(CAMPAIGN_TYPE.update)}
          >
            Quick update
          </button>
        </div>
        <div className="layout__item u-1/3">
          <button
            type="button"
            className={buttonClassName(campaignType === CAMPAIGN_TYPE.recurring)}
            onClick={onClick(CAMPAIGN_TYPE.recurring)}
          >
            Automated Campaign
          </button>
        </div>
      </div>
    </div>
  );
};
SelectCampaignType.propTypes = {
  campaignType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SelectCampaignType;
